import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import CommentModel from '@/views/Project/Comment/models/comment'

import Editor from '@/components/Editor/Editor.vue'
import Mentions from '@/_components/editorJS/mentions.vue'
import AttachmentBtn from '@/views/Attachment/components/btn/btn.vue'
import AttachmentModel from '@/views/Attachment/model/attachment'
import ThreadModel from '@/views/Project/Comment/models/thread'

@Component({
    inheritAttrs: false,
    name: 'comment-input-component',
    components: { Editor, Mentions, AttachmentBtn },
})
export default class CommentInputComponent extends Mixins<MixinInterface>() {
    @Prop() comment!: CommentModel
    @Prop() parent!: CommentModel
    @Prop() thread!: ThreadModel

    commentId = this.geneateEditorId()
    body = this.comment && this.comment.body ? JSON.stringify(this.comment.body) : null

    geneateEditorId() {
        return `comment-${
            this.comment
                ? this.comment._id
                : this.parent
                ? this.parent._id
                : this.thread
                ? this.thread._id
                : null
        }-${Date.now()}`
    }

    get valid() {
        return (
            this.body ||
            (this.comment && this.comment.attachments.length > 0) ||
            this.attachments.length > 0
        )
    }

    loadingAttachments = false
    loading = false
    attachments: Array<any> = []

    onGetAttachments(attachments: Array<any>) {
        if (this.comment) {
            this.postAttachment(attachments, this.comment)
        } else {
            this.attachments = [...this.attachments, ...attachments]
        }
    }

    async postAttachment(attachments: Array<any>, comment: CommentModel) {
        try {
            this.loadingAttachments = true
            if (comment) {
                await Promise.all(
                    attachments.map(async (file) => {
                        await AttachmentModel.post('comment', file.id, comment)
                    })
                )

                await comment.get()
            }
        } finally {
            this.loadingAttachments = false
        }
    }

    deleteAttachment(index) {
        this.attachments.splice(index, 1)
    }

    // Mentions
    setMentionedUser(user) {
        let dataJSON
        if (this.body) {
            dataJSON = JSON.parse(this.body)
        } else {
            dataJSON = {
                type: 'editorjs',
                data: {
                    time: Date.now(),
                    version: '2.8.1',
                    blocks: [],
                },
            }
        }

        dataJSON.data.blocks.push({
            type: 'paragraph',
            data: {
                text: `<span class="vbit-mention" data-user="${user.id}" >@${user.name}</span>&nbsp;`,
            },
        })
        this.body = JSON.stringify(dataJSON)

        this.commentId = this.geneateEditorId()
    }

    onPassComment(data) {
        this.body = data
    }

    onSave() {
        if (this.comment) {
            this.update()
        } else if (this.parent) {
            this.reply()
        } else if (this.thread) {
            this.post()
        }
    }

    async update() {
        if (this.valid) {
            this.loading = true
            await this.comment.updateBody(this.body)
            this.close()
            this.loading = false
        }
    }

    async reply() {
        if (this.parent && this.valid) {
            this.loading = true
            let comment = await this.parent.reply(this.body)
            if (this.attachments.length > 0) {
                await this.postAttachment(this.attachments, comment)
            }
            this.body = null
            this.attachments = []
            this.commentId = this.geneateEditorId()
            this.loading = false
        }
    }

    async post() {
        if (this.thread && this.valid) {
            try {
                this.loading = true
                let comment = await this.thread.postComment(this.body)

                if (this.attachments.length > 0) {
                    await this.postAttachment(this.attachments, comment)
                }
                this.close()
                this.$emit('onPostComment', comment._id)
            } finally {
                this.loading = false
            }
        }
    }

    close() {
        this.body = null
        this.attachments = []
        this.commentId = this.geneateEditorId()
        this.$emit('close', null)
    }

    get writableAttachments() {
        return this.comment ? this.comment.writable('attachments') : true
    }
}
